function extractShopifyText(block: any): string {
  if (!block) return ''
  if (typeof block === 'string') return block
  if (Array.isArray(block)) {
    return block.map(extractShopifyText).join(' ')
  }
  if (typeof block === 'object') {
    let text = ''
    if (typeof block.value === 'string') {
      text += block.value
    }
    if (Array.isArray(block.children)) {
      text += ' ' + block.children.map(extractShopifyText).join(' ')
    }
    return text.trim()
  }
  return ''
}

export default extractShopifyText